import Simulate from './form'

export default Simulate
export {Simulate}
